import type { FacilityException } from '../types/facilityWorkspace';

const humanize = (value: string | null | undefined, fallback: string) => {
  const text = String(value || '').trim();
  return text ? text.replace(/_/g, ' ') : fallback;
};

export const facilityExceptionTitle = (item: FacilityException): string => {
  if (item.source_table === 'abf_outbound_exchange') {
    return 'Accounting delivery rejected';
  }
  return humanize(item.title || item.type, 'Facility exception');
};

export const facilityExceptionDescription = (item: FacilityException): string => {
  if (item.source_table === 'abf_outbound_exchange') {
    return 'The downstream administrator rejected the accounting delivery. Review the persisted acknowledgement evidence before republishing.';
  }

  const description = String(item.description || '').trim();
  if (!description) {
    return `${humanize(item.status, 'Open')} · ${humanize(item.source, 'Persisted evidence')}`;
  }

  // Historical negative-control evidence can contain implementation-stage labels.
  // Keep that evidence in the read model, but do not make it the primary business UX.
  return description.replace(/\bPhase\s+\d+\s+negative control:\s*/gi, '').trim();
};
